<template>
  <div class="outlet-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">

          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-bind:label="$t('client.opening_times')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="banner.config.opening_times" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.special_dates')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="banner.config.special_dates" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.public_holiday')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="banner.config.public_holiday" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="banner.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import cSwitch from '../../../components/Switch'
import Customization from './Customization'

export default {
  name: 'BannerForm',
  props: {
    value: {
      type: Object
    }
  },
  components: {
    Customization,
    cSwitch
  },
  data: function () {
    return {
      position_fields: [
        'name_seo',
        'level'
      ],
      banner: {
        basic_info: [],
        fields: [],
        config: {
          fix_banner: false,
          special_dates: false,
          opening_times: false,
          public_holiday: false
        },
        list: []
      },
      banner_config : {}
    }
  },
  methods: {
    updateData () {
      // Update Base Info
      if (this.value != null && this.value.basic_info != null) {
        let basicInfo = {}
        for (let i in this.value.basic_info) {
          basicInfo[this.value.basic_info[i].type] = {
            show: this.value.basic_info[i].show,
            disable: this.value.basic_info[i].disable
          }
        }

        for (let i in this.banner.basic_info) {
          if (basicInfo[this.banner.basic_info[i].type] != null) {
            this.banner.basic_info[i].show = basicInfo[this.banner.basic_info[i].type].show
            this.banner.basic_info[i].disable = basicInfo[this.banner.basic_info[i].type].disable
          }
        }
      }

      // Update List Info
      if (this.value != null && this.value.list != null) {
        let basicInfo = {}
        for (let i in this.value.list) {
          basicInfo[this.value.list[i].type] = {
            show: this.value.list[i].show,
            disable: this.value.list[i].disable
          }
        }

        for (let i in this.banner.list) {
          if (basicInfo[this.banner.list[i].type] != null) {
            this.banner.list[i].show = basicInfo[this.banner.list[i].type].show
            this.banner.list[i].disable = basicInfo[this.banner.list[i].type].disable
          }
        }
      }

      // Update Config
      if (this.value != null && this.value.config != null) {
        for (let i in this.banner.config) {
          if (this.value.config[i] != null) {
            this.banner.config[i] = this.value.config[i]
          }
        }
      }

      // Update customization field
      if (this.value != null && this.value.fields != null) {
        this.banner.fields = this.value.fields
      }
    }
  },
  created: function () {
  },
  mounted: function () {
    this.updateData()
  },
  watch: {
    banner: {
      handler: function (newValue) {
        this.$emit('input', this.banner)
        this.$emit('change', this.banner)
      },
      deep: true
    },
    value: {
      handler: function (newValue) {
        this.updateData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/BannerForm.vue